import { CalendarManager, Conference, ISetParams } from '@benzinga/calendar-manager';
import { Session } from '@benzinga/session';
import { injectLogos } from '../lib/utils';
import { logCalendarFetchFailure } from '../lib/utils/logCalendarFetchFailure';

const fetchConferenceCall = (
  session: Session,
  params: ISetParams = {},
  injectTickersLogos = true,
  pageSize = 100,
): Promise<Conference[]> => {
  return session
    .getManager(CalendarManager)
    .getCalendarData('conference', { ...params, pageSize })
    .then(res => {
      if (res.ok && res.ok.length) {
        const sortedData = res.ok.sort((a, b) => {
          const dateA = new Date(a.date || 0).getTime();
          const dateB = new Date(b.date || 0).getTime();
          return dateA - dateB;
        });
        return injectTickersLogos ? injectLogos(sortedData, session) : sortedData;
      }
      return [];
    })
    .catch(error => {
      logCalendarFetchFailure('conference-calls', error);
      return [];
    });
};

export { fetchConferenceCall };
